import Toolbar from 'common/components/Toolbar'
import ImportExportTab from './ImportExportTab'

const ImportExportToolbar = () => {
  return (
    <Toolbar className='border-none px-0'>
      <ImportExportTab />
    </Toolbar>
  )
}

export default ImportExportToolbar
